import * as React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../store.ts";

export interface LoadingCellsState {
  cells: Record<string, "pending">;
}

const initialState: LoadingCellsState = { cells: {} };

export const loadingCellsSlice = createSlice({
  name: "loadingCells",
  initialState,
  reducers: {
    cellIsPending: (
      state,
      {
        payload,
      }: PayloadAction<{
        cell: string;
      }>,
    ) => {
      state.cells[payload.cell] = "pending";
    },
    cellIsLoaded: (
      state,
      {
        payload,
      }: PayloadAction<{
        cell: string;
      }>,
    ) => {
      delete state.cells[payload.cell];
    },
  },
});

export const useSetCellLoading = () => {
  const dispatch = useAppDispatch();
  const setCellLoading = React.useCallback(
    (cell: string) => {
      dispatch(loadingCellsSlice.actions.cellIsPending({ cell }));
    },
    [dispatch],
  );
  const setCellLoaded = React.useCallback(
    (cell: string) => {
      dispatch(loadingCellsSlice.actions.cellIsLoaded({ cell }));
    },
    [dispatch],
  );
  return { setCellLoading, setCellLoaded };
};

export const useCellLoadingStatus = (cell: string) =>
  useAppSelector((state) => state.loadingCells.cells[cell] === "pending");

export const useAllLoadingCells = () =>
  useAppSelector((state) => [...Object.keys(state.loadingCells.cells)]);
